import React, { Component } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import * as constants from '../../Constatnts'
import { isNullOrUndefined } from 'util';
import Icon from '../2/Controls/Icon';

class EmployeeDashboard extends Component {

    constructor() {
        super();
        this.state = {
            employees: []
            , topEmployees: []
            , employeeProductTypes: []
            , stores: []
            , storeList: []
            , searchStore: ""
            , searchCashRegister: ""
            , searchTransactionType: ""
            , searchTransactionTypeName : 'All'
            , rightHeight:40
            , searchTransactionFromDate: new Date().toISOString().split('T')[0]
            , searchTransactionToDate: new Date().toISOString().split('T')[0],
        };

        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.onSearchClick = this.onSearchClick.bind(this);
        this.onClearSearch = this.onClearSearch.bind(this);
        this.getRandomColor = this.getRandomColor.bind(this);
        this.loadEmployeeDashboard = this.loadEmployeeDashboard.bind(this);
        this.onStoreChange = this.onStoreChange.bind(this)
        this.onExportClick = this.onExportClick.bind(this);
    };

    componentDidMount() {
        this.setState({ storeID: this.props.user.store.key })
        let storeList = []
        storeList.push({ value: this.props.user.store.key })

        this.props.getUserStores(this.props.user.user.RegistrationID, "").then((stores) => {                
            this.setState({ stores: stores })
        });
    this.setState({ storeList: storeList, storeID: this.props.user.store.key });

        this.loadEmployeeDashboard(storeList, this.state.searchTransactionFromDate,
            this.state.searchTransactionToDate,this.state.searchTransactionType);
    };

   onExportClick() {

    this.props.getEmployeeDashboard(
        this.props.user.user.RegistrationID,
        this.state.storeList,
        this.state.searchTransactionFromDate,
        this.state.searchTransactionToDate,
        "10000",
        this.state.searchTransactionType
    )
    .then((result) => {

        if (
            isNullOrUndefined(result.EmployeeProductTypeWise) ||
            result.EmployeeProductTypeWise.length === 0
        ) {
            this.props.getToastr("No Record Found");
            return;
        }

        let employees = [];

        result.EmployeeProductTypeWise.map((data) => {

            let employee = {

                "Employee Name": data.name,

                "Store Name":
                    this.state.stores.filter(
                        (s) => s.key === data.storeID
                    )[0].StoreName,

                "Bill Count": data.total_transactions,

                "Services":
                    data.product_types.hasOwnProperty("Services")
                    ? data.product_types["Services"].total_sales
                    : 0,

                "Products":
                    data.product_types.hasOwnProperty("Products")
                    ? data.product_types["Products"].total_sales
                    : 0,

                "Package Sold":
                    data.product_types.hasOwnProperty("Package")
                    ? data.product_types["Package"].total_sales
                    : 0,

                "Wallet":
                    data.product_types.hasOwnProperty("Wallet Recharge")
                    ? data.product_types["Wallet Recharge"].total_sales
                    : 0,

                "Total": data.total_sales,

                "Gross Total": data.total_gross_sales
            };

            employees.push(employee);

        });

        const csvData = constants.objToCSV(employees);

        const csvBlob = new Blob(
            [csvData],
            { type: "text/csv" }
        );

        const url = window.URL.createObjectURL(csvBlob);

        const a = document.createElement("a");

        a.setAttribute("hidden", "");

        a.setAttribute("href", url);

        a.setAttribute(
            "download",
            "EmployeeProductTypeWise.csv"
        );

        document.body.appendChild(a);

        a.click();

        document.body.removeChild(a);

    });

}
    
    handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.onSearchClick()
        }
    }

    getRandomColor() {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }
//
  
 
 
  

   loadEmployeeDashboard(storeList, searchTransactionFromDate, searchTransactionToDate, searchTransactionType) {

    this.props.getEmployeeDashboard(
        this.props.user.user.RegistrationID,
        storeList,
        searchTransactionFromDate,
        searchTransactionToDate,
        "10000",
        searchTransactionType
    ).then((result) => {

        // Employee Performance Chart
        let employees = {
            labels: [],
            datasets: [
                {
                    label: 'Staff',
                    backgroundColor: [],
                    hoverBackgroundColor: [],
                    data: []
                }
            ]
        };

        result.searchResult.map((data) => {

            employees.labels.push(data.name);
            employees.datasets[0].data.push(data.total_sales);

            let color = this.getRandomColor();

            employees.datasets[0].backgroundColor.push(color);
            employees.datasets[0].hoverBackgroundColor.push(color);

        });

        // Top 3 Employees
        let topEmployees = result.searchResult.slice(0, 3);

        this.setState({
            employees: employees,
            topEmployees: topEmployees,
            employeeProductTypes: result.EmployeeProductTypeWise || []
        });

    });
};

    onSearchClick() {
        this.setState({ searchFrom: 0, loading: true})
        this.loadEmployeeDashboard(this.state.storeList,
            this.state.searchTransactionFromDate,
            this.state.searchTransactionToDate,
            this.state.searchTransactionType);
    };

    onClearSearch() {
        let storeList = []
        storeList.push({ value: this.props.user.store.key});

        this.setState({storeList : storeList, 
            searchTransactionFromDate: new Date().toISOString().split('T')[0]
            , searchTransactionToDate: new Date().toISOString().split('T')[0]
            ,searchTransactionType : ''
        })
        this.loadEmployeeDashboard(storeList, new Date().toISOString().split('T')[0], new Date().toISOString().split('T')[0], '')
    };

    onStoreChange(e){
        let storeList = []
        // console.log("key", e.target.value);
        if (e.target.value != "") {
            storeList.push({value: e.target.value})
        }
        else
        {
            for (let i = 0; i < this.state.stores.length; i++) {
                const store = this.state.stores[i];
                storeList.push({ value: store.key })
            }
        }
        // console.log("storeList", JSON.stringify(storeList));
        this.setState({ storeList: storeList, storeID: e.target.value })
    }

    render() {
        return <div className="content-wrapper">
            <section className="content" >
                <div className="row">
                    <div className="col-md-12 col-xs-12" style={{marginBottom:"10px"}}>
                        <div className="row">
                            <div className="col-md-6 col-xs-12">
                                <font style={{ fontSize: "30px", marginBottom: "4px" }}>Employee Insight</font>
                            </div>
                            <div className="col-xs-8 hidden-md hidden-lg hiddn-xl hidden-sm" style={{paddingRight:"0px"}}>
                                <select type="text" className="form-control" 
                                        value={this.state.storeID}
                                        onChange={this.onStoreChange}>
                                        <option value="">All Stores</option>
                                        {this.state.stores.filter((e) => !e.IsDeleted).map((store) =>
                                            <option value={store.key}>{store.StoreCode}-{store.StoreName}</option>
                                        )}
                                    </select>
                            </div>   
                            <div className="col-xs-4 hidden-md hidden-lg hiddn-xl hidden-sm" style={{paddingLeft:"0px"}}>
                                <select type="text" className="form-control"
                                        onChange={(evt) => this.setState({ searchTransactionType: evt.target.value,searchTransactionTypeName: evt.target.options[evt.target.selectedIndex].text })}
                                        value={this.state.searchTransactionType}>
                                        <option value="">All</option>
                                        {this.props.config.TransactionTypes.filter((e) => e.Module === "sales" && !e.IsDeleted).map((e) => <option value={e.key}>{e.TransactionType}</option>)}
                                </select>   
                            </div>
                            <div className="col-xs-5 hidden-md hidden-lg hiddn-xl hidden-sm" style={{paddingRight:"0px"}}>
                                <input type="date" className="form-control" 
                                        onChange={(evt) => this.setState({ searchTransactionFromDate: evt.target.value })}
                                        value={this.state.searchTransactionFromDate} onKeyPress={this.handleKeyPress}/>
                            </div>
                            <div className="col-xs-5 hidden-md hidden-lg hiddn-xl hidden-sm" style={{padding:"0px"}}>
                                <input type="date" className="form-control" 
                                        onChange={(evt) => this.setState({ searchTransactionToDate: evt.target.value })}
                                        value={this.state.searchTransactionToDate} onKeyPress={this.handleKeyPress} /> 
                            </div>
                            <div className="col-xs-2 hidden-md hidden-lg hiddn-xl hidden-sm" style={{paddingLeft:"0px"}}>
                                        <button type="button" 
                                        style={{width:"100%",height:"34px"}}
                                        className="btn btn-primary btn-flat btn-md fa fa-search" 
                                        disabled={this.state.searchTransactionFromDate === '' || this.state.searchTransactionToDate===''}
                                        onClick={this.onSearchClick}></button>     
                            </div>                            
                            <div className="col-md-6  hidden-xs">
                                <div className="input-group pull-right">
                                    <select type="text" className="form-control" style={{ width: "25%" }}
                                        value={this.state.storeID}
                                        onChange={this.onStoreChange}>
                                        <option value="">All Stores</option>
                                        {this.state.stores.filter((e) => !e.IsDeleted).map((store) =>
                                            <option value={store.key}>{store.StoreCode}-{store.StoreName}</option>
                                        )}
                                    </select>
                                    <select type="text" className="form-control" style={{ width: "23%" }}
                                        onChange={(evt) => this.setState({ searchTransactionType: evt.target.value,searchTransactionTypeName: evt.target.options[evt.target.selectedIndex].text })}
                                        value={this.state.searchTransactionType}>
                                        <option value="">All</option>
                                        {this.props.config.TransactionTypes.filter((e) => e.Module === "sales" && !e.IsDeleted).map((e) => <option value={e.key}>{e.TransactionType}</option>)}
                                    </select>
                                    <input type="date" className="form-control" style={{ width: "23%" }}
                                        onChange={(evt) => this.setState({ searchTransactionFromDate: evt.target.value })}
                                        value={this.state.searchTransactionFromDate} onKeyPress={this.handleKeyPress}/>
                                    <input type="date" className="form-control" style={{ width: "24%" }}
                                        onChange={(evt) => this.setState({ searchTransactionToDate: evt.target.value })}
                                        value={this.state.searchTransactionToDate} onKeyPress={this.handleKeyPress} /> 
                                    <button type="button" className="btn btn-primary btn-flat btn-md fa fa-search" style={{ width: "5%",padding: "9px" }}
                                            disabled={this.state.searchTransactionFromDate === '' || this.state.searchTransactionToDate===''}
                                        onClick={this.onSearchClick}></button>                                   
                                </div>
                            </div>                      
                        </div>
                    </div>
                    <div>
                        <div className="box-body">
                            <div className="row">
                                <div className="col-md-6 col-sm-6 col-xs-12">
                                    <div className="box box-success">
                                        <div className="box-header with-border">
                                            <h3 className="box-title">Employee Performance</h3>
                                        </div>
                                        <div className="box-body">
                                            <div className="chart" style={{height:this.state.rightHeight + "vh"}}>
                                                <Doughnut
                                                    width={150}
                                                    height={70}
                                                    data={this.state.employees}
                                                    options={{
                                                        maintainAspectRatio: false
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-sm-6 col-xs-12">
                                    <div className="box box-success">
                                        <div className="box-header with-border">
                                            <h3 className="box-title">Top Peformer</h3> 
                                        </div>
                                        <div className="box-body">
                                            {this.state.topEmployees.length > 0 && <div style={{height:this.state.rightHeight + "vh"}}>
                                                {this.state.topEmployees.map((employee) =>
                                                    <React.Fragment>
                                                        <div className="info-box info-blue" >
                                                                <div className="info-box-icon ">
                                                                    <Icon type="trophy"/>
                                                                </div>
                                                                <div className="info-box-content">
                                                                    <div className="info-box-text">{employee.name}</div>
                                                                    <div className="info-box-number">
                                                                        {Number(employee.total_sales).toFixed(0)}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/* <span className="info-box-icon" style={{background:"transparent",lineHeight:'15px',marginTop:"70px",width:"170px" }}>
                                                                <i className="fa fa-trophy" style={{ color: this.getRandomColor()}}></i>
                                                                <br></br>
                                                                <span className="info-box-text">{employee.name}</span>
                                                                <br></br>
                                                                <span className="info-box-number"><i className="fa fa-inr"/>{employee.total_sales}</span>
                                                            </span> */}
                                                    </React.Fragment>
                                                )}
                                            </div>}
                                            {this.state.topEmployees.length === 0 && "No records found"}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                            <div className="col-md-12 col-sm-12 col-xs-12">
                            <div className="box box-success">
                                        <div className="box-header with-border">
                                            <h3 className="box-title">Employee Wise</h3>
                                            <button className="btn btn-default btn-flat btn-md pull-right"
                                                style={{ marginRight: "5px" }}
                                                onClick={this.onExportClick}
                                            ><i className="glyphicon glyphicon-download-alt " ></i></button>
                                        </div>
                                        <div className="box-body">
                                            <div className="table-responsive">
                                                {this.state.employeeProductTypes.length > 0 && <table className="table no-margin">
                                                    <thead>
                                                        <tr>
                                                            <th>Employee</th>
                                                            <th>Bill Count</th>
                                                            <th>Services</th>
                                                            <th>Products</th>
                                                            <th>Package Sold</th>
                                                            <th>Wallet</th>
                                                            <th>Total</th>
                                                            <th>Gross Total</th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.employeeProductTypes.map((empProd) =>
                                                            <tr>
                                                                <td>{empProd.name}</td>
                                                                <td>{empProd.total_transactions}</td>
                                                             <td>
    <span>
        <i className="fa fa-inr"/>
        {
            empProd.product_types.hasOwnProperty("Services")
            ? empProd.product_types["Services"].total_sales
            : 0
        }
    </span>
</td><td>
    <span>
        <i className="fa fa-inr"/>
        {
            empProd.product_types.hasOwnProperty("Products")
            ? empProd.product_types["Products"].total_sales
            : 0
        }
    </span>
</td>
<td>
    <span>
        <i className="fa fa-inr"/>
        {
            empProd.product_types.hasOwnProperty("Package")
            ? empProd.product_types["Package"].total_sales
            : 0
        }
    </span>
</td>
<td>
    <span>
        <i className="fa fa-inr"/>
        {
            empProd.product_types.hasOwnProperty("Wallet Recharge")
            ? empProd.product_types["Wallet Recharge"].total_sales
            : 0
        }
    </span>
</td>
                                                                  <td><span><i className="fa fa-inr"/>{empProd.total_sales}</span></td>
                                                                <td><span><i className="fa fa-inr"/>{empProd.total_gross_sales}</span></td>
                                                                <td><Link to={{ pathname: "/home/employeeworksheet", state: { key: empProd.employeeID, name:empProd.name, 
                                                                        searchTransactionFromDate: this.state.searchTransactionFromDate
                                                                        , searchTransactionToDate: this.state.searchTransactionToDate
                                                                        ,searchTransactionType: this.state.searchTransactionType, searchTransactionTypeName: this.state.searchTransactionTypeName } }}
                                                                        type="button" className="btn btn-md btn-default "><i className="fa fa-edit"></i></Link></td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>}
                                                {this.state.employeeProductTypes.length === 0 && "No records found"}
                                            </div>
                                        </div>
                                    </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    };
};
export default EmployeeDashboard;